import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PONDERACIONAPI } from '../const';

export type CronoResponseItem = { f_fin: string; f_inicio: string; instancias: string };
type CronoResponse = CronoResponseItem[];

type State = { data: null | CronoResponse[]; error: string; loading: boolean; success: string };
const initialState: State = { data: null, error: '', loading: false, success: '' };

type GetValues = { idLlamadoConcurso: number };
export const getTablaCronograma = createAsyncThunk<CronoResponse[], GetValues>(
  'cronograma/gettabla',
  async ({ idLlamadoConcurso }) => {
    const resp = await axios.get(
      `${PONDERACIONAPI}/cronograma/ByIdLlamadoConcurso/${idLlamadoConcurso}`,
    );

    return resp.data;
  },
);

type PostValues = { idLlamadoConcurso: number; valores: any };
export const postTablaCronograma = createAsyncThunk<void, PostValues>(
  'cronograma/posttabla',
  async ({ idLlamadoConcurso, valores }) => {
    const final = {
      id_llamado_concurso: idLlamadoConcurso,
      cronograma: valores, //.filter((e: any) => e.f_inicio || e.f_fin),
    };
    await axios.post(`${PONDERACIONAPI}/cronograma`, final);
  },
);

const cronogramaSlice = createSlice({
  name: 'cronograma',
  initialState,
  reducers: {
    cleanMsg: (state) => ({ ...state, success: '', error: '' }),
  },
  extraReducers: (builder) => {
    builder.addCase(getTablaCronograma.pending, (state) => {
      return { ...state, loading: true, data: null };
    });
    builder.addCase(getTablaCronograma.fulfilled, (state, action) => {
      return { ...state, loading: false, data: action.payload };
    });
    builder.addCase(getTablaCronograma.rejected, (state, action) => {
      return { ...state, loading: false, error: 'No se pudo obtener el cronograma' };
    });
    builder.addCase(postTablaCronograma.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(postTablaCronograma.rejected, (state) => {
      return { ...state, loading: false, error: 'No se pudo guardar la info' };
    });
    builder.addCase(postTablaCronograma.fulfilled, (state) => {
      return { ...state, loading: false, success: 'El cronograma se guardo correctamente' };
    });
  },
});

export const { cleanMsg } = cronogramaSlice.actions;
const cronogramaReducer = cronogramaSlice.reducer;
export default cronogramaReducer;
